import { render } from "./ViewCriterion.vue?vue&type=template&id=0bc265cb&scoped=true"
import script from "./ViewCriterion.vue?vue&type=script&lang=js"
export * from "./ViewCriterion.vue?vue&type=script&lang=js"

import "./ViewCriterion.vue?vue&type=style&index=0&id=0bc265cb&scoped=true&lang=css"

import exportComponent from "/Users/sandhiyabaskar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc265cb"]])

export default __exports__